export interface GenericViewItem {
  readonly id: string;
  readonly text: string;
}

export interface MgCountry {
  readonly id: string;
  readonly shortName: string;
  readonly text: string;
  readonly imageUrl: string;
}

export interface MapLocations {
  locationId: string;
  name?: string;
  latitude?: string;
  longitude?: string;
}

export const OBJ_MAX_GRP_DISTANCE_BTW_COORD = {
  0: 5000.0,
  1: 5000.0,
  2: 5000.0,
  3: 5000.0,
  4: 5000.0,
  5: 5000.0,
  6: 4000.0,
  7: 3000.0,
  8: 2000.0,
  9: 1000.0,
  10: 400.0,
  11: 200.0,
  12: 120.0,
  13: 110.0,
  14: 10.0,
  15: 10.0,
  16: 10.0,
  17: 10.0,
  18: 1.0,
  19: 1.0,
  20: 1.0,
  21: 1.0,
  22: 1.0,
}; // standard zoom 12 to 120
export interface MapMarkerGroup2Show {
  locationIds: string[];
  locId2markerGroupId: { [locationId: string]: string };
  mapMarkerGroup: MapMarkerGroup;
}
export interface MapMarkerGroup {
  [locationId: string]: ObjMarkerGroup;
}
export interface ObjMarkerGroup {
  locationsId: string[];
  name: string;
  latitude: string;
  longitude: string;
  label: LabelObjMarker;
  icon: object;
}
interface LabelObjMarker {
  text: string;
  color?: string;
  font?: string;
  fontSize?: string;
}

export interface ServiceOrderItem {
  readonly name: string;
  readonly displayOrder: number;
  readonly filterOrder: number;
}

export interface LocationSearchQuery {
  address?: string;
  searchRadius?: number;
  limit?: number;
  country?: string;
  radiusuom?: string;
  amazonCard?: boolean;
  sendMoney?: boolean;
  receiveMoney?: boolean;
  billPayment?: boolean;
  reloadOtherCard?: boolean;
  addToPhone?: boolean;
  formFreeCompletion?: boolean;
  directToAccount?: boolean;
  payPal?: boolean;
  moneyOrder?: boolean;
  xpressPackage?: boolean;
  purchaseMoneygramCard?: boolean;
  reloadMoneygramCard?: boolean;
  receiveToCard?: boolean;
  expressPayment?: boolean;
  purpose?: string;
}

export interface LocationSearchResult {
  readonly radius: number;
  readonly locations: MgLocation[];
  readonly labels?: LocationLabels;
  readonly services: ServiceOrderItem[];
  readonly error?: any;
}

export interface MgLocation {
  readonly locationDetails: LocationDetail;
  readonly locationOperatingHours: LocationOperatingHours;
  readonly locationPhone: LocationPhone;
  readonly locationServices: LocationResultServices;
  expandLocationCard: boolean | false;
}

export interface LocatorLabel {
  readonly selectPayLocationTxt: string;
  readonly selectPickupLocationTxt: string;
  readonly selectLocationBtnTxt: string;
  readonly findLocationTxt: string;
  readonly changeLocation: string;
  readonly depositLocation: string;
  readonly searchInputTxt: string;
  readonly filterServiceTxt: string;
  readonly locationsMatchedTxt: string;
  readonly viewMoreServicesTxt: string;
  readonly openUntilTxt: string;
  readonly backBtnTxt: string;
  readonly currentlyOpenTxt: string;
  readonly currentlyClosedTxt: string;
  readonly closingSoonTxt: string;
  readonly closedTxt: string;
  readonly closedOpenTxt: string;
  readonly hoursOperationTxt: string;
  readonly noLocationAvailable: string;
  readonly unableToLocation: string;
  readonly typeNewAddress: string;
  readonly agentURLTextUK: string;
  readonly agentURLTextFinland: string;
}

export interface LocationDetail {
  readonly name?: string;
  readonly locationId?: string;
  readonly kioskId?: string;
  readonly addressLine1?: string;
  readonly addressLine2?: string;
  readonly addressLine3?: string;
  readonly city?: string;
  readonly state?: string;
  readonly country?: string;
  readonly postalCode?: string;
  readonly zipCode?: string;
  readonly distance?: string;
  readonly distanceuom?: string;
  readonly retailerId?: string;
  readonly latitude?: string;
  readonly longitude?: string;
  readonly agentName?: string;
  readonly agentURL?: string;
  readonly bankAccountRequired?: string;
}

export interface LocationOperatingHours {
  readonly monHours: string;
  readonly tueHours: string;
  readonly wedHours: string;
  readonly thuHours: string;
  readonly friHours: string;
  readonly satHours: string;
  readonly sunHours: string;
}

export interface LocationPhone {
  readonly addToPhone: boolean;
  readonly phone: string;
}

export interface LocationResultServices {
  readonly sendMoney: boolean;
  readonly receiveMoney: boolean;
  readonly billPayment: boolean;
  readonly reloadOtherCard: boolean;
  readonly addToPhone: boolean;
  readonly formFreeCompletion: boolean;
  readonly directToAccount: boolean;
  readonly payPal: boolean;
  readonly moneyOrder: boolean;
  readonly recCurrencies: string;
  readonly sendCurrencies: string;
  readonly xpressPackage: boolean;
  readonly purchaseMoneygramCard: boolean;
  readonly reloadMoneygramCard: boolean;
  readonly receiveToCard: boolean;
  readonly expressPayment: boolean;
  readonly amazonCard: boolean;
}

export interface LocationLabels {
  readonly 'locator.services': string;
  readonly 'locator.thuHours': string;
  readonly 'locator.tueHours': string;
  readonly 'locator.sendCurrencies': string;
  readonly 'locator.receiveMoney': string;
  readonly 'locator.receiveToCard': string;
  readonly 'locator.sendMoney': string;
  readonly 'locator.moneyOrder': string;
  readonly 'locator.reloadMoneygramCard': string;
  readonly 'locator.amazonCard': string;
  readonly 'locator.hours': string;
  readonly 'locator.friHours': string;
  readonly 'locator.recCurrencies': string;
  readonly 'locator.wedHours': string;
  readonly 'locator.satHours': string;
  readonly 'locator.monHours': string;
  readonly 'locator.purchaseMoneygramCard': string;
  readonly 'locator.payPal': string;
  readonly 'locator.reloadOtherCard': string;
  readonly 'locator.purchase.money.order': string;
  readonly 'locator.billPayment': string;
  readonly 'locator.distance.MI.to.KM': string;
  readonly 'locator.sunHours': string;
  readonly 'locator.addToPhone': string;
  readonly 'locator.hours.warning': string;
  readonly 'locator.xpressPackage': string;
}

export interface LocationSearchRequest {
  address: string;
  agent?: string;
  country: string;
  latitude?: string;
  limit: number;
  longitude?: string;
  purpose?: string;
  radiusuom: string;
  searchRadius: number;
  serviceOptions?: string;
}

export interface LocationSearchResponse {
  locations: MgLocation;
  radius: number;
}

export enum Who {
  map = 'MAP',
  listResult = 'LIST_RESULT',
}
